module.exports = __webpack_public_path__ + "img/advance1.369e0f6c.png";